module.exports = __webpack_public_path__ + "static/media/IIAC_Rules.b7843d1e.pdf";